import { Box } from '@rbilabs/universal-components';

import { InnerLayout } from 'components/layout/styled';

import { LoyaltyBackground } from '../loyalty-background';

const IncentivesGridDefault = {
  width: 'full',
  flex: 1,
};

const IncentivesGridWidget = {
  display: 'flex',
};

const StyledIncentivesGrid = LoyaltyBackground.withConfig<{
  incentiveSelected: boolean;
  isWidget: boolean;
}>(p => (p.isWidget ? IncentivesGridWidget : IncentivesGridDefault));

export const IncentivesGrid = StyledIncentivesGrid.withConfig<{
  incentiveSelected: boolean;
  isWidget: boolean;
}>({
  width: {
    md: '100%',
  },
  height: {
    md: 'calc(100vh - 149px)',
  },
});

export const IncentiveItemsContainer = Box.withConfig({
  padding: 0,
});

export const IncentiveList = Box.withConfig({
  flexGrow: 0,
  padding: 0,
  margin: 0,
  maxHeight: '100%',
});

export const IncentiveDetails = Box.withConfig({
  borderLeftWidth: '1px',
  borderLeftStyle: 'solid',
  borderLeftColor: Styles.color.grey.four,
});

export const IncentivesGridContainer = InnerLayout.withConfig({
  paddingY: '$0',
});
